import { render, staticRenderFns } from "./TeamTable.vue?vue&type=template&id=44db4de4&scoped=true&"
import script from "./TeamTable.vue?vue&type=script&lang=js&"
export * from "./TeamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db4de4",
  null
  
)

export default component.exports